
import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import GenericBoard from '../Button/ButtonCard/GenericBoard';
import './Card.css';
import BntStandard from '../PopUps/BntStandard';
import { Box, Typography } from '@mui/material';

/**
 * GenericIOS component renders a card with generic board information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleGeneric - The callback function to handle generic IOS board.
 * @param {Function} props.handleGenericDecrement - The callback function to handle decrement of generic IOS board.
 * @param {Boolean} props.reset - Whether to reset the generic IOS board.
 */
const GenericIOS = ({
    /**
     * The callback function to handle generic IOS board.
     */
    handleGeneric,module,handleDecrement,
    /**
     * The callback function to handle decrement of generic IOS board.
     */
    
    /**
     * Whether to reset the generic IOS board.
     */
    reset
  }) => {
    const [open, setOpen] = useState(false);
  
    /**
     * Handles the click event to open the generic IOS board popup.
     */
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    return (
      <Card variant="outlined" sx={{
        /**
         * Custom styles for the card container
         */
        width: '430px',
        height: '180px',
        border: 'none',
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
      }}>
        <CardContent>

              <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 2
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontFamily: 'Open Sans',
                        m: 0,
                        
                        fontWeight: 'bold',
                      }}
                    >
            Generic IOS
                    </Typography>
          
                   <BntStandard size="small" onClick={handleClickOpen}>
           
            </BntStandard>
                  </Box>
       
  
          <GenericBoard
            text='Generic IOS'
            onClick={()=>handleGeneric(module)}
            handleGenericDecrement={()=>handleDecrement(module)}
            reset={reset}
          />
  
          <p   style={{
            fontFamily: 'Open Sans',
            fontSize: '12px',
            marginRight: '16%'
          }}>
An ADHA-compliant 3U generic expansion board 
built around the PolarFire FPGA
          </p>
  
        
        </CardContent>
      </Card>
    );
  };
  
  /**
   * Exports the GenericIOS component as the default export.
   */
  export default GenericIOS;